// components/ShowWrappedDialog.tsx
import { Share1Icon } from '@radix-ui/react-icons';
import { Button } from '@radix-ui/themes';
import { Capacitor } from '@capacitor/core';
import { Share } from '@capacitor/share';
import { alertModal } from 'helpers/confirmation';
import { pushEvent } from 'helpers/crmUtils';
import { getShareBaseUrl } from 'helpers/utils';

export const ShareHeaderButton: React.FC<{ url: string; name: string; type: string }> = ({ url, name, type }) => {
  const handleShare = async () => {
    const shareUrl = url.startsWith('/') ? `${getShareBaseUrl()}${url}` : url;
    const shareTitle = `Guarda ${name} su TennisTalker!`;

    try {
      if (Capacitor.isNativePlatform()) {
        await Share.share({
          title: shareTitle,
          url: shareUrl,
          dialogTitle: `Condividi ${type}`,
        });
      } else if (navigator.share && navigator.canShare && navigator.canShare({ url: shareUrl })) {
        await navigator.share({
          title: shareTitle,
          url: shareUrl,
        });
      } else {
        await navigator.clipboard.writeText(shareUrl);
        alertModal('Link copiato negli appunti!');
      }

      pushEvent(`TT - EVENT - Click to Share ${type}`);
    } catch (error) {
      console.error('Error sharing:', error);
    }
  };

  return (
    <div id='share'>
      <Button variant='outline' className='hover:cursor-pointer' onClick={handleShare}>
        <Share1Icon className='min-w-fit p-1' />
      </Button>
    </div>
  );
};
